<template>
    <div class="index-box">
        <div class="index-title">我的活码</div>
        <div class="tips-danger d-flex justify-content-between align-items-center">
          <span>温馨提醒：禁止上传违法违规内容，禁止将本功能用于违法、违规用途，一经发现立即停用活码并封停账号</span>
          <img class="close" src="//static.3wt.cn/static/home-3wcn/images/icon-close.png" alt="">
        </div>
        <div class="code-name d-flex">
          <p>活码名称：</p>
          <span id="liveCodeName">加群加粉活码w</span>
          <button class="modify-name">修改名称</button>
        </div>
      <div class="group-presentation d-flex">
        <p>页面展示内容</p>
        <button class="modify-name d-flex align-items-center">
          <img src="//static.3wt.cn/static/home-3wcn/images/icon-group-edit.png" alt="">
        </button>
      </div>
      <div class="d-flex justify-content-between">
        <div class="group-edit-wrapper">
          <div class="group-list-wrapper">
            <div class="add-group-list" style="display: none;">+ 添加分组</div>
            <hr>
            <ul>
              <input hidden="" id="qrLiveCodeGroupLength" value="0">

            </ul>
          </div>
          <div class="no-group-wrapper">
            <img src="//static.3wt.cn/static/home-3wcn/images/icon-nogroup.png" alt="">
            <p>您尚未创建分组</p>
            <div class="create-group-btn">立即创建</div>
          </div>
        </div>
        <div class="code-content" style="width: calc(100% - 220px);">
          <div class="d-flex justify-content-between align-items-center mb-17">
            <div class="group-title"></div>
            <div class="d-flex justify-content-end">
              <button class="batch-modify">批量修改访问上限</button>
              <button class="batch-del">批量删除</button>
            </div>
          </div>
          <div class="code-nav d-flex justify-content-between align-items-center">
            <input id="liveCodecheckAll" type="checkbox" class="check-box">
            <div class="code-priority">优先级</div>
            <div class="code-thumbnail">二维码缩略图</div>
            <div class="crowd-name">群码名称</div>
            <div class="code-invalid-data">失效日期</div>
            <div class="code-toplimit">访问上限</div>
            <div class="code-toplimit">累计扫码</div>
            <div class="code-operate">操作</div>
          </div>
          <ul>

            <li class="code-list d-flex justify-content-center align-items-center">
              <button class="btn-add d-flex justify-content-center align-items-center" id="addQrCode">
                <img src="//static.3wt.cn/static/home-3wcn/images/icon-add.png" alt="">
                <span>添加二维码</span>
              </button>
            </li>
          </ul>
          <div class="tips-upload">注：单个分组最多添加200个二维码</div>
          <div class="sequence-switch d-flex">
            <label for="radioOrder">
              <li class="d-flex justify-content-between align-items-center cursor-pointer">
                <!-- <div class="unchecked checked"></div> -->
                <input id="radioOrder" type="radio" name="checkboxa" value="1" onclick="checkedSwitchMode(this.value)">
                <i class="unchecked"></i>
                <div>
                  <p>顺序切换二维码</p>
                  <span>二维码访问人数到达阈值后切换下一张</span>
                </div>
              </li>
            </label>
            <label for="radioRandom">
              <li class="d-flex justify-content-between align-items-center cursor-pointer">
                <input id="radioRandom" type="radio" name="checkboxa" value="2" onclick="checkedSwitchMode(this.value)">
                <i class="unchecked"></i>
                <div>
                  <p>随机切换二维码</p>
                  <span>用户扫描后随机展示您上传的二维码</span>
                </div>
              </li>
            </label>
            <label for="radioPolling">
              <li class="d-flex justify-content-between align-items-center cursor-pointer">
                <input id="radioPolling" type="radio" name="checkboxa" value="3" onclick="checkedSwitchMode(this.value)">
                <i class="unchecked"></i>
                <div>
                  <p>轮询切换二维码</p>
                  <span>平均展示你的二维码</span>
                </div>
              </li>
            </label>
          </div>
          <div class="sequence-switch d-flex">
            <label for="distinctFlag">
              <li class="d-flex justify-content-between align-items-center switch-mode" style="cursor:pointer;">
                <input id="distinctFlag" type="checkbox" class="check-box" onclick="checkedDistinctFlag(1)" style="opacity: 1;margin-left: 0;margin-right: 10px">
                <div>
                  <p>用户定位</p>
                  <span>每个设备扫描活码后绑定固定二维码</span>
                </div>
              </li>
            </label>
          </div>
          <button class="btn-sub mt-30 btn-sub-center" id="toManageLiveCode">生成活码</button>
        </div>
      </div>
    </div>

</template>

<script>
    import QRCode from 'qrcodejs2';
    export default {
        name: "GroupingLiveCodee",
        data() {
            const validateUrl = (rule, value, callback) => {
                const isUrl = this.$common.containSpecial(value);
                console.log(isUrl)
                console.log(value)
                if (value === '') {
                    callback(new Error('请输入要转换的长链接'));
                }else if (isUrl){
                    callback(new Error('请不要输入特殊字符'));
                } else {
                    callback();
                }
            };
            return {
                ruleForm: {
                    url: '',
                },
                rules: {
                    url: [
                        { validator: validateUrl, trigger: 'blur' }
                    ],
                },
                shortId: 0,
                shortUrl: "123456789",
                isShowResult: false,
                param:'1'
            }
        },
        mounted() {
        },
        methods: {
            submitForm() {
                this.$refs.urlForm.validate((valid) => {
                    if (valid) {
                        this.zh();
                    }
                });
            },
            async zh() {
                const postData = {
                    url: this.ruleForm.url,
                };
                const {ret,data} = await this.$api.shortUrl.zh(postData);
                if (ret === 1000){
                    this.$message.success("转换成功");
                    this.shortId = data.id;
                    this.shortUrl = data.url;
                    this.isShowResult = true;
                    this.bindQRCode();
                }
            },
            urlClear() {
                this.shortId = "";
                this.shortUrl = "";
                this.isShowResult = false;
                this.$refs.qrCodeDiv.innerHTML = '';
            },
            urlInput(val) {
                if (val === ''){
                    this.shortId = "";
                    this.shortUrl = "";
                    this.isShowResult = false;
                    this.$refs.qrCodeDiv.innerHTML = '';
                }
            },
            batchConversion() {
                this.$router.push('/tabs/batchConversion');
            },
            bindQRCode() {
                const txt = this.shortUrl;
                if (txt === '') return;
                this.$refs.qrCodeDiv.innerHTML = '';
                new QRCode(this.$refs.qrCodeDiv, {
                    text: txt,
                    width: 200,
                    height: 200,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                });
            },
            savePic() {
                let myQrCode = this.$refs.qrCodeDiv.getElementsByTagName('canvas');
                let a = document.createElement('a');
                a.href = myQrCode[0].toDataURL('image/png');
                a.download = this.shortUrl;
                a.click();
            },
            copyUrl() {
                const msg = this.$message;
                if (this.shortUrl === ''){
                    msg.error('复制的内容为空！');
                    return;
                }
                this.$copyText(this.shortUrl).then(function (e) {
                    msg.success('复制成功');
                }, function (e) {
                    msg.error('复制失败！');
                });
            },
            changeActive(){

              $('.tips-groug-wen-info').css("display",'block');
            },
            removeActive(){
              $('.tips-groug-wen-info').css("display",'none');
            }
        },
    }
</script>

<style scoped>
    .index-box{
        width: 940px;
        height: auto;
        margin-left: 80px;
        padding: 30px 120px 30px 40px;
    }
    .index-box .index-title{
        width: 100%;
        height: 28px;
        font-size: 20px;
        margin-bottom: 40px;
    }
    .index-box .btn-box{
        width: 100%;
    }
    .result-box{
        width: 100%;
        height: auto;
        padding-top: 40px;
    }
    .result-box .top-ico{
        width: 840px;
        height: 40px;
        color: #07cc00;
        font-size: 24px;
        text-align: center;
        line-height: 40px;
        margin-left: 100px;
        margin-bottom: 20px;
    }
    .result-box .top-ico i{
        display: inline-block;
        font-size: 40px;
        margin-right: 10px;
        vertical-align: top;
    }
    .result-box .item{
        width: 100%;
        height: auto;
        padding-bottom: 20px;
    }
    .result-box .item .l{
        display: inline-block;
        width: 100px;
        height: 40px;
        color: #606266;
        font-size: 14px;
        text-align: right;
        line-height: 40px;
        padding-right: 12px;
        vertical-align: top;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .result-box .item .m{
        display: inline-block;
        width: 720px;
        height: 40px;
        vertical-align: top;
    }
    .result-box .item .r{
        display: inline-block;
        width: 98px;
        height: 40px;
        margin-left: 22px;
        vertical-align: top;
    }
    .result-box .item .lab{
        display: inline-block;
        width: 100px;
        color: #606266;
        font-size: 14px;
        text-align: right;
        line-height: 40px;
        padding-right: 12px;
        vertical-align: top;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .result-box .item .qrCode{
        display: inline-block;
        width: 200px;
        height: 200px;
        vertical-align: top;
    }
    .result-box .item .dl-btn{
        display: inline-block;
        width: 112px;
        height: 120px;
        margin-left: 40px;
        padding-top: 80px;
        vertical-align: top;
    }

    .clear{clear: both;}

    .about-box{margin-top: 50px;}
    .about-box .index-title2{padding: 10px 0px;font-size: 18px;color:red;}
    .about-box .about-s{width:220px;margin-right:10px;float:left;background:#f4f7f369;height:90px;margin-top: 10px;}
    .about-box .about-s .about-s-main{padding:15px;}
    .about-box .title2{font-weight: bold;padding:20px 0;}
    .about-box .about-s b{font-size:14px;font-weight: bold;color:#2d5dee;}
    .about-box i{font-size:20px;   }
    .about-box p{font-size: 14px;}
    ul{
      padding:0; list-style:none;
      margin:150px 150px;
    }
    li{
      width:80px; height:50px;
      display:inline-block;
      border-radius:8px; border:1px #000 solid;
      text-align:center; line-height:50px;
      cursor:pointer;
      transition:all 0.3s linear;
      margin-left:5px;
    }
    li:hover{
      background-color:#0CF; color:#fff;
      border:1px #fff solid;
    }
    li.checked{
      background-color:#0CF; color:#fff;
      border:1px #fff solid;
    }
    .tips-danger {
      width: 100%;
      height: 40px;
      background: rgba(255, 249, 249, 1);
      margin: 0 auto;
      line-height: 40px;
      font-size: 14px;
      color: rgba(248, 52, 55, 1);
      font-weight: 400;
      /*padding: 0 10px;*/
      margin-top: -2px;
    }
    .tips-danger > .close {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    .code-name {
      margin-top: 20px;
      font-size: 16px;
      margin-bottom: 30px;
    }
    .code-name .modify-name {
      font-size: 14px;
      font-weight: 400;
      color: #277cf2;
      margin-left: 11px;
    }
    button {
      border: 0 none;
      background-color: transparent;
      cursor: pointer;
    }
    .code-nav {
      width: 100%;
      height: 50px;
      background: rgba(245, 247, 246, 1);
      /*padding: 0 19px;*/
    }
    .d-flex {
       display: -webkit-box!important;
      display: -ms-flexbox!important;
       display: -webkit-flex!important;
       display: flex!important;
    }
    .align-items-center {
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
    }
    .justify-content-between {
      -webkit-box-pack: justify!important;
      -ms-flex-pack: justify!important;
      -webkit-justify-content: space-between!important;
      justify-content: space-between!important;
    }
    .justify-content-between {
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
    }
    .d-flex {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
    }
    .content-box .content .check-box {
      position: relative;
      width: 14px;
      height: 14px;
      border: 1px solid #C7C8CB;
      vertical-align: -8%;
    }
    .code-content .check-box {
      position: relative;
      width: 14px;
      height: 14px;
      border: 1px solid #C7C8CB;
      vertical-align: middle;
      margin-left: 10px;
    }
    .code-nav .code-priority {
      width: 10%;
      text-align: center;
      line-height: 50px;
    }
    blockquote, body, code, dd, div, dl, dt, fieldset, figure, form, h1, h2, h3, h4, h5, h6, input, legend, li, ol, p, pre, td, textarea, th, ul {
      margin: 0;
      padding: 0;
      list-style: none;
      -webkit-tap-highlight-color: transparent;
      color: #4D4D4D;
    }
    .code-nav .code-thumbnail {
      width: 20%;
      text-align: center;
      line-height: 50px;
    }
    .code-nav .crowd-name {
      width: 20%;
      text-align: center;
      line-height: 50px;
    }
    .code-nav .code-invalid-data {
      width: 20%;
      text-align: center;
      line-height: 50px;
    }
    .code-nav .code-toplimit {
      width: 8%;
      text-align: center;
      line-height: 50px;
    }
    .code-nav .code-operate {
      width: 8%;
      text-align: center;
      line-height: 50px;
    }
    .code-content .code-list {
      width: 100%;
      /*padding: 20px 19px;*/
      border-bottom: 1px solid #F2F2F2;
      box-sizing: border-box;
      min-height: 146px;
    }
    .align-items-center {
       -webkit-box-align: center!important;
      -ms-flex-align: center!important;
       -webkit-align-items: center!important;
       align-items: center!important;
    }
    .code-content .code-list .btn-add {
      width: 160px;
      height: 34px;
      border-radius: 2px;
      border: 1px solid #277cf2;
    }
    .code-content .code-list .btn-add img {
      margin-left: 20px;
      width: 12px;
      height: 12px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      border: none;
      vertical-align: middle;
    }
    .code-content .code-list .btn-add span {
      font-size: 14px;
      color: #277cf2;
      margin-left: 8px;
      line-height: 34px;
    }
    .code-content .code-list:nth-last-of-type(1):hover {
      background: #ffffff;
      cursor: pointer;
    }
    .code-content .code-list:hover {
      background: rgba(245, 247, 246, 1);
      cursor: pointer;
    }
    .content-box .content {
      margin-left: 220px;
      width: calc(100% - 610px);
      min-width: 650px;
      min-height: 560px;
      padding: 27px 30px;
      background-color: #fff;
      box-shadow: 0 2px 5px rgb(0 0 0 / 5%);
      position: relative;
      font-family: PingFang-SC-Medium, PingFang-SC;
      position: relative;
    }
    button {
      writing-mode: horizontal-tb !important;
      font-style: ;
      font-variant-ligatures: ;
      font-variant-caps: ;
      font-variant-numeric: ;
      font-variant-east-asian: ;
      font-weight: ;
      font-stretch: ;
      font-size: ;
      font-family: ;
      text-rendering: auto;
      color: -internal-light-dark(black, white);
      letter-spacing: normal;
      word-spacing: normal;
      line-height: normal;
      text-transform: none;
      text-indent: 0px;
      text-shadow: none;
      text-align: center;
      cursor: default;
    }
    .code-content .code-list {
      width: 100%;
      /*padding: 20px 19px;*/
      border-bottom: 1px solid #F2F2F2;
      box-sizing: border-box;
      min-height: 146px;
    }
    .content-box .content .check-box {
      position: relative;
      width: 14px;
      height: 14px;
      border: 1px solid #C7C8CB;
      vertical-align: -8%;
    }
    .code-content .check-box {
      position: relative;
      width: 14px;
      height: 14px;
      border: 1px solid #C7C8CB;
      vertical-align: middle;
      margin-left: 10px;
    }
    .code-content .code-list .code-priority {
      width: 10%;
      text-align: center;
      line-height: 85px;
    }
    .code-content .code-list .code-thumbnail {
      width: 20%;
      text-align: center;
      line-height: 85px;
    }
    .code-content .code-list .code-thumbnail img {
      height: auto;
      max-height: 100px;
      width: auto;
    }
    .code-content .code-list .crowd-name {
      width: 20%;
      text-align: center;
      line-height: 85px;
    }
    .code-content .code-list .code-invalid-data {
      width: 20%;
      text-align: center;
      line-height: 85px;
    }
    .code-content .code-list .code-toplimit {
      width: 8%;
      text-align: center;
      line-height: 85px;
    }
    .code-content .code-list .code-operate {
      width: 8%;
      text-align: center;
      /*line-height: 85px;*/
    }
    .code-content .code-list .code-operate .btn-edit {
      margin-right: 10px;
      color: #919191;
    }
    .code-content .code-list .code-operate .btn-del {
      color: #919191;
    }
    .tips-upload {
      font-size: 12px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: rgba(145, 145, 145, 1);
      line-height: 17px;
      margin-top: 6px;
    }
    .sequence-switch {
      margin-top: 30px;
    }
    .sequence-switch div:nth-of-type(1) {
      margin-right: 88px;
    }

    .text1{
      margin-left:10px ;
    }
    .text1 p{
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .text1  span {
      display: block;
      font-size: 12px;
      font-weight: 400;
      color: rgba(145, 145, 145, 1);
      margin-top: 6px;
    }
    .sequence-switch div:nth-of-type(2) {
      margin-right: 88px;
    }
    .content-box .content .check-box {
      position: relative;
      width: 14px;
      height: 14px;
      border: 1px solid #C7C8CB;
      vertical-align: -8%;
    }
    .btn-sub {
      width: 120px;
      height: 34px;
      background: #277cf2;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 34px;
    }
    .mt-30 {
      margin-top: 30px;
    }
    .group-presentation {
      font-size: 16px;
      margin: 20px 0 27px;
    }
</style>
